import React, { useEffect } from "react";
import { AdPromotionStatus, AdsSortOption, AdStatus } from "./../../../../models/enums";
import { AllPromotionStatus, AllTypeCategory } from "../../../../models";

export interface SearchCriteriaI {
  status?: number;
  title?: string;
  module?: string;
  adPromotionFilter?: number;
  ExpireSoon?: boolean;
  ExpirationSort?: boolean;
  sortOption?: string;
}

const AdStatusOptions = [
  { name: "Svi oglasi", value: 0 },
  { name: "Aktivni", value: AdStatus.active },
  { name: "Uskoro istječu", value: AdStatus.expireSoon },
  { name: "Pauziran", value: AdStatus.paused },
  { name: "Prodano", value: AdStatus.sold },
  { name: "Istekli", value: AdStatus.expired }
];

const AdPromotionFilterOptions = [
  { name: "Nisu istaknuti", value: AdPromotionStatus.inactive },
  { name: "Istaknuti", value: AdPromotionStatus.active },
  { name: "Aktivno reisticanje", value: AdPromotionStatus.auto }
];

interface TabsProps {
  children?: React.DetailedReactHTMLElement<any, HTMLElement>;
  onTabChange?: Function;
  statistic?: number[];
  status?: number;
  adPromotionFilter?: number;
  updateStatistics?: Function;
  deleteAdTrigger: string | null;
  renewAdTriggerId: string | null;
  renewAdTriggerFromEmail?: boolean;
}

const Tabs: React.FC<TabsProps> = (props) => {
  const {
    statistic,
    onTabChange,
    status,
    adPromotionFilter,
    children
  } = props;

  const [searchCriteria, setSearchCriteria] = React.useState({
    status,
    adPromotionFilter,
    title: undefined,
    module: undefined,
    ExpireSoon: undefined,
    ExpirationSort: undefined,
    sortOption: AdsSortOption.DateDesc,
  });

  useEffect(() => {
    setSearchCriteria(prev => ({
      ...prev,
      ExpireSoon: (status == AdStatus.expireSoon ? true : undefined),
      ExpirationSort: (status == AdStatus.expireSoon ? true : undefined),
      status: (status == AdStatus.expireSoon ? undefined : status)
    }));
  }, [status]);

  const handleModuleSearch = (value: string) => {
    setSearchCriteria(prev => ({
      ...prev,
      module: (value === AllTypeCategory.name ? undefined : value)
    }));
  };

  const handleTextSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target === null) return;


    const title = e.target.value.length > 2 ? e.target.value : undefined;


    setSearchCriteria(prev => ({
      ...prev,
      title
    }));
  };

  const handlePromotionStatusSearch = (value: any) => {
    setSearchCriteria(prev => ({
      ...prev,
      adPromotionFilter: (value === AllPromotionStatus.name ? undefined : value)
    }));
  };

  const onSortOptionChange = (value: any) => {
    setSearchCriteria(prev => ({
      ...prev,
      sortOption: value
    }));
  };

  return (
    <section className="my-ads-page custom-tab">
      {
        React.cloneElement(children, {
          status,
          adPromotionFilter,
          AdStatusOptions,
          AdPromotionFilterOptions,
          onTabChange,
          statistic,
          searchCriteria,
          onSetSearchCriteria: setSearchCriteria,
          onModuleSearch: handleModuleSearch,
          onTextSearch: handleTextSearch,
          onPromotionStatusSearch: handlePromotionStatusSearch,
          onSortOptionChange,
          ...props
        })
      }
    </section>
  );
};

export default Tabs;



// WEBPACK FOOTER //
// ./src/containers/MyAdsPage/MyAds/Tabs/index.tsx